<div>
    <iframe [src]="embedLocation" id="asset-content" scrolling="no"></iframe>
</div>
